enum ApprovalsCommentStatusFilter {
    Open = "open",
    Pending = "pending",
    Mentioned = "mentioned",
    Resolved = "resolved",
    None = "none"
}

enum AIReviewCommentStatusFilter {
    All = "all",
    Open = "open",
    Resolved = "resolved"
}

enum CommentStatusFilter {
    Open = "open",
    Mentioned = "mentioned",
    Resolved = "resolved",
    None = "none"
}

enum AnnotationStatusFilter {
    All = "all",
    Mentioned = "mentioned",
    None = "none"
}

export default CommentStatusFilter;
export { AnnotationStatusFilter, ApprovalsCommentStatusFilter, AIReviewCommentStatusFilter };
